import { Component, OnInit } from '@angular/core';
import { PropertiesService } from '../properties.service';
import { DeviceType } from '../website-preview/website-preview.component';

@Component({
  selector: 'app-preview-page',
  templateUrl: './preview-page.component.html',
  styleUrls: ['./preview-page.component.scss']
})
export class PreviewPageComponent implements OnInit {
  private currentDeviceType: DeviceType = DeviceType.IPHONE;

  public deviceType = DeviceType;

  private setDeviceType = (deviceType: DeviceType) => {
    this.currentDeviceType = deviceType;
  }

  constructor(private properties: PropertiesService) { }

  ngOnInit() {
  }

}
